import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import Grid from '@mui/material/Grid2'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import AddBotToGroup from './AddBotToGroup'
function TournamentSocial() {
  const { id } = useParams()
  return (
    <Container sx={{ mt: 8, mb: 15 }}>
      <div role="presentation" style={{ textAlign: 'left', width: '100%' }}>
        <Breadcrumbs maxItems={2} aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/tournaments-list">
            Турниры
          </Link>
          <Link underline="hover" color="inherit" href={'/tournaments/' + id}>
            Редактирование
          </Link>
          <Typography sx={{ color: 'text.primary' }}>Соц.Сети</Typography>
        </Breadcrumbs>
      </div>
      <Grid container spacing={2} style={{ width: '100%' }}>
        <AddBotToGroup />
      </Grid>
    </Container>
  )
}
export default TournamentSocial
